require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-10-07-bubble-2-0.json") })
        }
      }, "path---articles-2005-10-07-bubble-2-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-10-07-bubble-2-0!./.cache/json/articles-2005-10-07-bubble-2-0.json
// module id = 432
// module chunks = 231608221292675